import * as types from './action-types';
import {getCollection, getCollectionApps} from '../services/market-api';
import _ from 'lodash';

export const verticalsList = [
  {'title': 'vertical.title.business', 'key': 'business'},
  {'title': 'vertical.title.online-store', 'key': 'online-store'},
  {'title': 'vertical.title.photography', 'key': 'photography'},
  {'title': 'vertical.title.music', 'key': 'music'},
  {'title': 'vertical.title.designer', 'key': 'design'},
  {'title': 'vertical.title.restaurants', 'key': 'restaurants'},
  {'title': 'vertical.title.accommodation', 'key': 'accommodation'},
  {'title': 'vertical.title.events', 'key': 'events'},
  {'title': 'vertical.title.blog', 'key': 'blog'},
  {'title': 'vertical.title.portfolio-cv', 'key': 'portfolio-cv'},
  {'title': 'vertical.title.other', 'key': 'other'}
];

export function fetchCollectionIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();

    const vertical = getVerticalSlug(state.mode.siteProfile.vertical);

    if (vertical !== state.collection.vertical) {
      return Promise.all([
        dispatch(fetchCollection(vertical, state.mode.lang)),
        dispatch(fetchCollectionApps(vertical, state.mode.lang, state.mode.experiments))
      ]);
    }
  };
}

// export function updateApp(app) {
//   return (dispatch, getState) => {
//     const state = getState();
//     const apps = state.collection.apps.map(i => {
//       if (i.appDefinitionId === app.appDefinitionId) {
//         return app;
//       } else {
//         return i;
//       }
//     });
//
//     dispatch(receiveCollectionApps(apps));
//   };
// }

function requestCollection(vertical) {
  return {
    type: types.REQUEST_COLLECTION,
    vertical
  };
}

function receiveCollection(json) {
  return {
    type: types.RECEIVE_COLLECTION,
    data: {...json},
    receivedAt: Date.now()
  };
}

function fetchCollection(vertical, lang) {
  return dispatch => {
    dispatch(requestCollection(vertical));

    return getCollection(vertical, lang)
      .then(json => dispatch(receiveCollection(json)))
      .catch(() => dispatch(receiveCollection({})));
  };
}

function requestCollectionApps() {
  return {
    type: types.REQUEST_COLLECTION_APPS
  };
}

export function receiveCollectionApps(json) {
  return {
    type: types.RECEIVE_COLLECTION_APPS,
    items: json.map(i => i),
    receivedAt: Date.now()
  };
}

function fetchCollectionApps(vertical, lang, experiments) {
  return dispatch => {
    dispatch(requestCollectionApps());

    return getCollectionApps(vertical, lang, experiments)
      .then(json => dispatch(receiveCollectionApps(json)))
      .catch(() => dispatch(receiveCollectionApps([])));
  };
}


function getVerticalSlug(vertical) {
  vertical = _.find(verticalsList, (i => i.key === vertical)) ? vertical : 'other';
  return 'market-2-0-' + vertical + '-collection';
}



// WEBPACK FOOTER //
// ./actions/collection.js